module.exports = __webpack_public_path__ + "static/img/minicard.17e4042.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/zcx/assets/images/minicard.jpg
// module id = 5jIi
// module chunks = 7